<template>
   <PageFrameContainer>
      <div v-html="getContent()"></div>
   </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";

    export default {
        name: "RefundPolicy",
        components: {PageFrameContainer},
        methods: {

            getContent() {
                return require(`@/locales/pages/refund-${this.$i18n.locale.toLowerCase()}.html`);
            }
        }
    }
</script>

<style scoped lang="scss">
   @import "/theme/theme.scss";
</style>